<template>
    <div class="home">
        <b-container>
            <div class="box mb-5" v-if="!onlyAccess">
                <h1><i class="far fa-users-class mr-4"></i>Register for a Conference</h1>
                <p>What is the <strong>Conference Code</strong>?</p>
                <b-input autocomplete="false" v-model="code" class="large"></b-input>

                <b-alert variant="danger" show v-if="error">{{ error }}</b-alert>

                <b-button variant="success" size="lg" block @click="registerConf()" :disabled="!code" class="mb-4">Register<i class="far fa-long-arrow-right"></i></b-button>

                <div class="mb-3">
                    <b-button variant="outline-success" block :to="{name: 'help'}"><i class="fas fa-question-square mr-2"></i> Need some help? View FAQs and Videos</b-button>
                </div>
            </div>

            <div class="box mt-0 mb-5" :class="{'mt-5': onlyAccess, 'pt-5': onlyAccess}">
                <div v-if="!access">
                    <b-button size="lg" variant="success" block @click="access=true"><i class="fas fa-id-badge mr-4"></i>Access Your Registrations & Records</b-button>
                </div>
                <div v-if="access && !instructions">
                    <h3><i class="far fa-id-badge mr-3"></i>Access Your Registrations & Records</h3>

                    <b-alert variant="warning" show v-if="onlyAccess" class="mt-5 mb-5">
                        <div class="mb-4 mt-3"><i class="far fa-comment-alt-exclamation mr-2 fa-3x"></i></div>
                        <strong>No conference was found by that code.</strong><br>Perhaps you provided your registration confirmation code? This is unnecessary. To access your conference registration simply click the link from your registration emails or enter your email address below.
                    </b-alert>

                    <p>What is your <strong>E-Mail Address</strong>?</p>
                    <b-input autocomplete="false" v-model="login"></b-input>
                    <b-button variant="success" size="lg" block :disabled="!login || processing" class="mb-3" @click="requestLogin">Submit</b-button>
                    <b-button variant="outline" @click="access=false; onlyAccess=false;">Cancel</b-button>
                </div>
                <div v-if="instructions">
                    <h3><i class="far fa-id-badge mr-3"></i>Access Your Registrations & Records</h3>
                    <p><i class="far fa-thumbs-up mr-2"></i>Great! We'll get an e-mail right over to grant you access to your information.</p>
                    <p class="mt-3">
                        <!--                        <b-button variant="outline" @click="help=true">I need more help...</b-button>-->
                    </p>
                </div>
            </div>

            <footer>
                <div>
                    <b-button variant="outline-light" :to="{name: 'login'}" class="login">Organization/Presenter Login<i class="fas fa-sign-in ml-2"></i></b-button>
                </div>

                <div class="mt-5">
                    <div><img src="@/assets/logo_white.png" class="logo mt-4"/></div>
                </div>

                <copyright class="mt-2" :hide="true"/>
            </footer>

        </b-container>
    </div>
</template>

<script>
    import Copyright from "../components/Copyright";
    import {mapActions} from 'vuex';

    export default {
        name: 'Home',
        components: {Copyright},
        data: function() {
            return {
                code: '',
                error: null,
                access: false,
                instructions: false,
                help: false,
                login: '',
                processing: false,
                onlyAccess: false
            };
        },
        methods: {
            ...mapActions(['getConferenceByCode', 'makeLoginRequest']),
            registerConf() {
                this.error = null;

                this.getConferenceByCode(this.code).then(result => {
                    this.$router.push('/register/' + result.code);
                }, err => {
                    if (this.code.length === 6) {
                        this.getConferenceByCode('INVALID;' + this.code); // Send just for logging purposes...
                        this.code = '';
                        this.onlyAccess = true;
                        this.access = true;
                    } else {
                        this.error = "I'm sorry, we can't find a conference by that code.  Please check the code and try again!";
                        console.log(err);
                    }
                });
            },

            requestLogin() {
                this.processing = true;
                this.login = this.login.trim();
                this.makeLoginRequest({request: this.login}).then(response => {
                    this.processing = false;
                    this.instructions = true;
                });
            }

        }
    };
</script>

<style lang="scss">

    @import '~@/assets/scss/_variables.scss';

    .home {
        background: darken($success, 15); /* fallback */
        background: linear-gradient(to bottom, $success, darken($success, 15));

        padding: 3rem 3rem 20rem;
        color: #5c5c5c;
        text-align: center;

        .logo {
            max-width: 350px;
        }

        .box {
            padding: 2rem 3rem;
            background: white;
            margin: 5rem;
            border-radius: 0.5rem;
            box-shadow: 0 0 39px 10px rgba(0, 0, 0, 0.2);

            h1, h3 {
                color: $green;
                letter-spacing: -0.08rem;
                margin-bottom: 2rem;
            }

            input {
                &.large {
                    font-weight: bold;
                    padding: 2.5rem;
                    letter-spacing: 0.3rem;
                    font-size: 2.5rem;
                }

                margin-bottom: 2rem;

                color: $green;
                text-align: center;
                text-transform: uppercase;
            }

            .btn {
                i {
                    margin-left: 0.7em;
                }
            }
        }

        footer {
            margin-top: 7rem;
        }
    }
</style>
